import { useState, useEffect } from "react";
import { ListLayout } from "../../../layouts";
import { Dialog, DataGrid } from "../../../components";
import {
  GrupoProdutosService,
  notification,
  ProdutosService,
} from "../../../services";
import { responseErros } from "../../../utils";
import AddGrupoProdutos from "../addGrupoProdutos/addGrupoProdutos.view";
import { PermisoesHelper } from "../../../helpers";

const ListGrupoProdutos = () => {
  const grupoProdutosService = new GrupoProdutosService();
  const permissoesHelper = new PermisoesHelper();
  permissoesHelper.validarPermisao("grupo-produtos-visualizar");
  const produtosService = new ProdutosService();
  const [loading, setLoading] = useState(false);
  const [grupoProdutosId, setGrupoProdutosId] = useState(null);
  const [produtosList, setProdutosList] = useState(null);
  const [openDialog, setOpenDialog] = useState(false);
  const [gruposProdutos, setGruposProdutos] = useState([]);
  const [rowCount, setRowCount] = useState(0);

  const colunas = [
    {
      field: "codigo",
      headerName: "Código",
      flex: 100,
    },
    {
      field: "descricao",
      headerName: "Descrição",
      flex: 700,
      filtrar: true,
    },
  ];

  useEffect(() => {
    buscaGruposProdutos();
    buscarProdutos();
  }, []);

  const buscaGruposProdutos = async (query) => {
    const filter = {
      ...query,
    };
    setLoading(true);
    const result = await grupoProdutosService.getAll(filter);
    if (!result.isAxiosError) {
      setRowCount(result.data.count);
      setGruposProdutos(result.data.rows);
    } else {
      responseErros(result);
    }
    setLoading(false);
  };

  const buscarProdutos = async (filtro) => {
    const filtros = {
      ...filtro,
    };
    setLoading(true);
    const res = await produtosService.getAll(filtros);
    if (!res.isAxiosError) {
      setProdutosList(res.data.rows);
    } else {
      responseErros(res);
    }
    setLoading(false);
  };

  const handleOpenDialog = (id) => {
    setGrupoProdutosId(id);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setGrupoProdutosId(null);
    setOpenDialog(false);
  };

  const handleDeleteGrupoProduto = async (id) => {
    const produto = produtosList.some((item) => item.grupoProdutoId === id);
    const retornoAlerta = await notification.confirmacao(
      "Excluir!",
      `Tem certeza que deseja excluir esse grupo de produto?`
    );
    if (retornoAlerta.isConfirmed) {
      if (produto) {
        notification.alertaGenericos(
          "Não se pode remover grupo inserido em outros cadastros"
        );
        return;
      }
      setLoading(true);
      const result = await grupoProdutosService.deletar(id);
      if (!result.isAxiosError) {
        buscaGruposProdutos();
        notification.deletadoSucesso();
      } else {
        setLoading(false);
        responseErros(result);
      }
    }
  };

  const sendServerDatagrid = (props) => {
    buscaGruposProdutos(props.filtros);
  };

  return (
    <ListLayout
      title="Grupos de Produtos"
      loading={loading}
      onClickCadastrar={handleOpenDialog}
      permissaoButton={permissoesHelper.temPermisao("grupo-produtos-cadastrar")}
    >
      <DataGrid
        rows={gruposProdutos}
        columns={colunas}
        onClickEdit={handleOpenDialog}
        onClickDelete={handleDeleteGrupoProduto}
        visualizarShow={permissoesHelper.temPermisao(
          "grupo-produtos-visualizar"
        )}
        editShow={permissoesHelper.temPermisao("grupo-produtos-editar")}
        deleteShow={permissoesHelper.temPermisao("grupo-produtos-excluir")}
        paginationMode={"server"}
        sendServer={(props) => sendServerDatagrid(props)}
        rowCount={rowCount}
        hideFiltroAvancado
      />
      <Dialog
        disableEscapeKeyDown
        fullWidth
        maxWidth="md"
        open={openDialog}
        aria-labelledby="form-dialog-title"
      >
        <AddGrupoProdutos
          id={grupoProdutosId}
          setCentrosCustos={setGruposProdutos}
          handleCloseDialog={handleCloseDialog}
          openDialog={openDialog}
          buscaGruposProdutos={buscaGruposProdutos}
        />
      </Dialog>
    </ListLayout>
  );
};

export default ListGrupoProdutos;
